module.exports = "/_next/static/images/eating-762777a2020fb898445423776c089fea.jpg";